<template>
<div class="site-statistics">
  <div id="siteDetailsDamageCharts" class="carousel slide" data-ride="carousel" data-interval="false">
    <div class="carousel-inner" role="listbox">

      <div class="carousel-item active" data-slide="0">
        <div class="damage-chart-wrapper">
          <div class="damage-chart">
            <GChart
              type="PieChart"
              :data="ratingFrequencyChart.data"
              :options="ratingFrequencyChart.options"
            />
          </div>
          <div class="damage-chart-title">Rating Frequency</div>
        </div>
      </div>
      <div class="carousel-item" data-slide="1">
        <div class="damage-chart-wrapper">
          <div class="damage-chart">
            <GChart
              type="PieChart"
              :data="worstCaseDamageFrequencyChart.data"
              :options="worstCaseDamageFrequencyChart.options"
            />
          </div>
          <div class="damage-chart-title">Worst Case Damage Across Location</div>
        </div>
      </div>
      <div 
        v-if="hasDefectTypeFrequencyStats"
        class="carousel-item" 
        data-slide="2"
      >
        <div class="damage-chart-wrapper">
          <div class="damage-chart">
            <GChart
              type="PieChart"
              :data="defectTypeFrequencyChart.data"
              :options="defectTypeFrequencyChart.options"
            />
          </div>
          <div class="damage-chart-title">Damage Types</div>
        </div>
      </div>
      <div 
        v-if="hasLocationFrequencyStats"
        class="carousel-item" 
        data-slide="3"
      >
        <div class="damage-chart-wrapper">
          <div class="damage-chart">
            <GChart
              type="PieChart"
              :data="locationFrequencyChart.data"
              :options="locationFrequencyChart.options"
            />
          </div>
          <div class="damage-chart-title">Damage Locations</div>
        </div>
      </div>
    </div>

    <button class="carousel-control-prev" type="button" data-bs-target="#siteDetailsDamageCharts" data-bs-slide="prev">
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#siteDetailsDamageCharts" data-bs-slide="next">
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>
    </button>
  </div>
</div>
</template>

<script>
import { GChart } from "vue-google-charts"

import helpers from "../../../helpers.js"

export default {
  components: {
    GChart
  },

  props: {
    statistics: Object
  },

  data: function () {
    return {
      chartOptions: {
        backgroundColor: {
          fill: 'transparent',
          stroke: 'transparent',
          strokeWidth: 0
        },
        pieSliceBorderColor: 'transparent',
        legend: "none",
        pieHole: 0.4,
        width: 250,
        height: 250,
        colors: []
      },
      ratingFrequencyChart: {
        data: []
      },
      worstCaseDamageFrequencyChart: {
        data: []
      },
      defectTypeFrequencyChart: {
        data: []
      },
      locationFrequencyChart: {
        data: []
      },
      isReady: false
    }
  },

  created: function() {
    window.google = undefined;
  },

  mounted: function() {
    const damageChartsCarousel = new bootstrap.Carousel('#siteDetailsDamageCharts')
  },

  computed: {
    hasRatingFrequencyStats: function() {
      return this.ratingFrequencyChart.data.length > 1
    },

    hasWorstCaseDamageFrequencyStats: function() {
      return this.worstCaseDamageFrequencyChart.data.length > 1
    },

    hasDefectTypeFrequencyStats: function() {
      return this.defectTypeFrequencyChart.data.length > 1
    },

    hasLocationFrequencyStats: function() {
      return this.locationFrequencyChart.data.length > 1
    },
  },

  methods: {
    setRatingFrequencyChart() {
      let vmStats = this

      let ratingFrequency = Object.entries(JSON.parse(this.statistics.ratingFrequency))

      ratingFrequency.unshift(["Rating", "Frequency"])

      // Set chart data
      this.ratingFrequencyChart.data = ratingFrequency.map(function(rating) {
        if (typeof rating[1] == "number") {
          return [helpers.damageMarks[rating[0]], rating[1]]
        }
        else {
          return rating
        }
      });

      // Set chart options
      this.ratingFrequencyChart.options = Object.assign({}, this.chartOptions);

      this.ratingFrequencyChart.options.pieSliceText = "label";

      this.ratingFrequencyChart.options.colors = ratingFrequency.reduce(function(colors, rating) {
        if (typeof rating[1] == "number") {
          colors.push(helpers.damageColors[rating[0]])
        }
        return colors
      }, []);
    },

    setWorstCaseDamageFrequencyChart() {
      let vmStats = this

      let worstCaseDamageFrequency = Object.entries(JSON.parse(this.statistics.worstCaseDamageFrequency))

      worstCaseDamageFrequency.unshift(["Worst Case Damage", "Accross Location"])

      // Set chart data
      this.worstCaseDamageFrequencyChart.data = worstCaseDamageFrequency.map(function(rating) {
        if (typeof rating[1] == "number") {
          return [helpers.damageMarks[rating[0]], rating[1]]
        }
        else {
          return rating
        }
      });

      // Set chart options
      this.worstCaseDamageFrequencyChart.options = Object.assign({}, this.chartOptions);

      this.worstCaseDamageFrequencyChart.options.pieSliceText = "label";

      this.worstCaseDamageFrequencyChart.options.colors = worstCaseDamageFrequency.reduce(function(colors, rating) {
        if (typeof rating[1] == "number") {
          colors.push(helpers.damageColors[rating[0]])
        }
        return colors
      }, []);
    },

    setDefectTypeFrequencyChart() {
      let vmStats = this

      let defectTypeFrequency = Object.entries(JSON.parse(this.statistics.defectTypeFrequency))

      defectTypeFrequency.unshift(["Damage", "Type"])

      // Set chart data
      this.defectTypeFrequencyChart.data = defectTypeFrequency

      // Set chart options
      this.defectTypeFrequencyChart.options = Object.assign({}, this.chartOptions);
      this.defectTypeFrequencyChart.options.pieSliceText = "none";
      this.defectTypeFrequencyChart.options.colors = helpers.chartColors;
    },

    setLocationFrequencyChart() {
      let vmStats = this

      let locationFrequency = Object.entries(JSON.parse(this.statistics.locationFrequency))

      locationFrequency.unshift(["Damage", "Location"])

      // Set chart data
      this.locationFrequencyChart.data = locationFrequency

      // Set chart options
      this.locationFrequencyChart.options = Object.assign({}, this.chartOptions);
      this.locationFrequencyChart.options.pieSliceText = "none";
      this.locationFrequencyChart.options.colors = helpers.chartColors;
    },

    getCharts: function() {
      // Set rating frequency chart props
      this.setRatingFrequencyChart()

      // Set worst case damage frequency chart props
      this.setWorstCaseDamageFrequencyChart()

      // Set worst case damage frequency chart props
      this.setDefectTypeFrequencyChart()

      // Set worst case damage frequency chart props
      this.setLocationFrequencyChart()
    }
  }
}
</script>